<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :incident-values="incidentValues"
            @form-submitted="submitForm"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/LovIncidents/Form.vue'
import { route } from '~@/Composables/route'

defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    },
    incidentValues: {
        type: Object,
        default: () => { return {} }
    }
})

function submitForm (form) {
    form.put(
        route('settings.incident-values.update', form.id)
    )
}
</script>

<style scoped>

</style>
